import { Injectable } from '@angular/core';
import { RequestConfigImplementation, REQUEST_METHODS, HTTPWrapperContext, XHR_STRATEGIES } from '@ptl/xhr';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { INeedMoreHelpResponse } from '../../../../shared/interfaces/need-more-help';

@Injectable({
  providedIn: 'root'
})

export class NeedMoreHelpService {

  constructor(private httpClient: HTTPWrapperContext) { }

  postNeedForHelp(data): Promise<INeedMoreHelpResponse> {
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/cmcsnr/v1/agentcubed/createlead',
      POST_OR_PUT_PAYLOAD: data,
      headers: new HttpHeaders({
        'x-hmhs-test-backend': environment.external.engen.eBill.overrideEnv
      })
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.WAS_INTER);
    return this.httpClient.makeRequest<any>(requestConfig);
  }
}
